import { BadgeBoard, LeaderboardBadge } from './badge.models';
import { RoUserFitnessStatsEntity, RoUserFitnessActivityStatsEntity } from '../../../meta-data/app-meta-data.service';

export interface FullStanding {
    IsMe?: boolean; IsFriend?: boolean; IsTeammate?: boolean;
    UserChallengeId?: number; ChallengeTeamId?: number; DisplayName: string; ProfileSlug?: string; TeamSlug?: string;
    Rank: number; Score: number; MetricTotal?: number; MemberCount?: number; ContributorCount?: number;
    AvatarMediaId?: number; AvatarMediaPath?: string; AvatarWidth?: number; AvatarHeight?: number;
    AvatarBackgroundColor?: string; AvatarTextColor?: string; Award?: LeaderboardBadge;
}
export interface FullStandings {
    State: 'pending' | 'ready' | 'changed'; PublicationId?: number; ScoreThroughDate?: string;
    FitnessActivityTypeId?: number; ActivityName?: string; MetricCode?: 'distance' | 'duration' | 'count';
    CountUnit?: string; AveragePerMember?: boolean; Page: number; PageSize: number; TotalCount: number;
    MyStanding?: FullStanding; Rows: FullStanding[]; Leaders?: FullStanding[];
    /** Browser-only expiry; a cache hit must not extend the original lifetime. */
    cacheExpiresAt?: number;
}
export interface OwnFitnessStats {
    State: 'pending' | 'ready'; Summary?: RoUserFitnessStatsEntity; Activities: RoUserFitnessActivityStatsEntity[];
}
export interface MetricBoard {
    board: BadgeBoard; loading: boolean; error: string; expanded: boolean; search: string; appliedSearch: string;
    searchVisible: boolean; audience: BoardAudience; focusId?: number;
    data?: FullStandings; leaders: FullStanding[];
    expiresAt?: number;
}
export type BoardAudience = 'all' | 'friends' | 'teammates';
export interface HeaderBadge { badge: LeaderboardBadge; subjectId: number; team: boolean; name?: string; }
export interface ActivityBoards { id: number; name: string; own: boolean; pinned: boolean; metrics: MetricBoard[]; }

export function activityGroups(boards: BadgeBoard[], teams: boolean, ownIds: number[], pins: number[]): ActivityBoards[] {
    const groups: ActivityBoards[] = [];
    boards.filter(b => b.IsRanked && b.IsTeam === teams && b.FitnessActivityTypeId > 0
        && ['distance', 'duration', 'count'].includes(b.MetricCode)).forEach(board => {
        let group = groups.find(g => g.id === board.FitnessActivityTypeId);
        if (!group) { group = {id: board.FitnessActivityTypeId, name: board.ActivityName, own: ownIds.includes(board.FitnessActivityTypeId),
            pinned: pins.includes(board.FitnessActivityTypeId), metrics: []}; groups.push(group); }
        group.metrics.push({board, loading: false, error: '', expanded: false, search: '', appliedSearch: '',
            searchVisible: false, audience: 'all', leaders: []});
    });
    return groups.sort((a, b) => Number(b.pinned) - Number(a.pinned) || a.name.localeCompare(b.name) || a.id - b.id);
}
export function visibleActivities(groups: ActivityBoards[], showAll: boolean, ownKnown: boolean): ActivityBoards[] {
    return groups.filter(g => showAll || !ownKnown || g.own || g.pinned);
}
export function leaderPercent(score: number, leader: number): number {
    return Number.isFinite(score) && leader > 0 ? Math.max(0, Math.min(100, score / leader * 100)) : 0;
}
export function standingScore(row: FullStanding, board: FullStandings): string {
    const value = board.MetricCode === 'distance' ? row.Score / 1609.344 : board.MetricCode === 'duration' ? row.Score / 3600 : row.Score;
    const unit = board.MetricCode === 'distance' ? 'mi' : board.MetricCode === 'duration' ? 'hr' : board.CountUnit || 'count';
    return value.toLocaleString(undefined, {maximumFractionDigits: 2}) + ' ' + unit + (board.AveragePerMember ? ' per member' : '');
}
